import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsCameraVideo } from "react-icons/bs";
import check from "../images/check.png";
import { FaTimesCircle } from "react-icons/fa";
import { GiAlarmClock } from "react-icons/gi";
import { LiaCalendarCheckSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
import { decryptData } from "../Services/TabServices";
import "../Loading.css";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import AppointmentPDF from "../DoctorDashboard/AppointmentPDF";
import { useSelector } from "react-redux";
import AppointmentEPriscription from "./AppointmentEPriscription";

interface Medicine {
  itemName: string;
  doseText: string;
  doseValue: number;
  forDays: number;
}

interface LabItem {
  serviceName: string;
    servicePrices: string;  
}

interface AppointmentDetail {
  CheifComplain: string;
  ProvisionalDiagnosis: string;
  TreatmentPlan: string;
  Medicines: Medicine[];
  LabItems: LabItem[];
}

interface DoctorInfo {
  doctorName: string;
  specializationName: string;
  appointmentDate: string;
  slotStartTime: string;
}

interface PatientInfo {
  patientName: string;
  dob: string;
  gender: string;
  address: string;
  phoneNo: string;
  // bloodGroup: string;
}

interface AppointmentDetail {
  CheifComplain: string;
  ProvisionalDiagnosis: string;
  TreatmentPlan: string;
  Medicines: Medicine[];
  LabItems: LabItem[];
}

interface AppointmentDetailPopupProps{
  appointment: {
    openAppointmentTab:string;
    appointmentId: number;
    name: string;
    specialty: string;
    doctorName:string;
    doctorFees:string;
    date: string;
    time: string;
    remarks: string;
      flag:string
  };
  onClose: () => void;
}

const AppointmentDetailModal: React.FC<AppointmentDetailPopupProps> = ({
  appointment,
  onClose,    
}) => {
    const token = sessionStorage.getItem("token");
      const storedUserId = sessionStorage.getItem("userId");
const userId = storedUserId ? decryptData(storedUserId) : null;
const navigate= useNavigate()
const patientProfile = useSelector(
(state: any) => state.userDetails
);
  const [isMobile, setIsMobile] = useState(false);
const [doctorInfo, setDoctorInfo] = useState<DoctorInfo | null>(null);
const [appointmentDetail, setAppointmentDetail]=useState<AppointmentDetail|null>(null);

const [patientInfo, setPatientInfo] = useState<PatientInfo>({
  patientName: patientProfile?.patientName || "",
  dob: patientProfile?.dob || "",
  gender: patientProfile?.gender || "",
  address: patientProfile?.address || "",
  phoneNo: patientProfile?.phoneNo || "",
});
  const [cancelling, setCancelling] = useState(false);
const [cancelMessage, setCancelMessage] = useState("Cancel Appointment");
const [showCancelSuccess, setShowCancelSuccess] = useState(false);
const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);

const getAppointmentDetails = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/Patient/GetAppointmentDetails`,{
      params:{
        appointmentId: appointment.appointmentId,
      },
    });

    const detailArray = response.data;
    if (Array.isArray(detailArray) && detailArray.length > 0){
      setAppointmentDetail(detailArray[0]);
    }else{
      setAppointmentDetail(null);
    }
  }catch(error){
    console.error('Error fetching appointment details:', error);
    setAppointmentDetail(null);
  }
};

useEffect(()=>{
  getAppointmentDetails();
},[])


const handleCancelAppointment = async () => {
  setCancelling(true);
  setCancelMessage("Cancelling Appointment...");
const payload = {
    // id: paymentDetails.appointmentId,
   id: appointment.appointmentId,
    UserId: userId,
    UserTypeId: "P",
    Reason: "",
    Remark: ""
  };
  try {
   
    await axios.post(
       `${process.env.REACT_APP_BASE_URL}/api/appointments/CancelAppointment`,
      {},
      { params: payload,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setShowCancelSuccess(true); // Show success
    setCancelMessage("Cancel Appointment");

    setTimeout(() => {

      setShowCancelSuccess(false);
      setShowCancelConfirmation(false); 
      onClose(); 
    }, 3000);
    //  navigate("/")
  }
   catch (error: any)
   {
    console.error("Error cancelling appointment:", error?.message || error);
    setCancelMessage("Failed to Cancel");
    setShowCancelConfirmation(false);
    setCancelling(false);
   }
};

 const handleCancelAppointmentpopup=()=> {
  setShowCancelConfirmation(false)
};

useEffect(() => {
  if (appointment) {
    setDoctorInfo({
      doctorName: appointment.doctorName,
      specializationName: appointment.specialty,
      appointmentDate: appointment.date,
      slotStartTime: appointment.time,
    });
  }
}, [appointment]);
 useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 498);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  

 
  return (
    
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 text-black "
      onClick={onClose}
    > 
    <div
  className={` w-[95%] max-w-2xl relative max-h-[90vh] overflow-y-auto ${
    appointment.flag! === "D" ? "p-0" : "p-6 bg-white rounded-2xl   shadow-xl"
  }`}
  onClick={(e) => e.stopPropagation()}
>
   {showCancelSuccess && (
  <div className="fixed inset-0 z-60 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] sm:w-[400px] text-center">
      <img src={check} alt="Success" className="w-8 h-8 mx-auto mb-4" />
      <p className="text-lg font-semibold ">Appointment Cancelled</p>
      <p className="text-sm mt-2">Your appointment has been successfully cancelled.</p>
    </div>
  </div>
)}
   {showCancelConfirmation && (
  <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className=" relative bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-md">
       <button
     onClick={() => setShowCancelConfirmation(false)}
        className="absolute top-2 right-2 text-gray-600 text-xl hover:text-black focus:outline-none"
        aria-label="Close"
      >
        ✖
      </button>
      <div className="text-center text-lg font-bold border-b pb-3 mb-4 text-[#184A84]">
        Cancel Appointment?
      </div> 
  
      <div className="flex flex-col sm:flex-row items-center gap-4 mb-4 border rounded-lg p-2 pl-4 shadow-inner">
      
        <div className="flex flex-col items-center sm:items-start">
          <p className="font-semibold text-[#333] text-center sm:text-left">
            {appointment.doctorName}
          </p>

          <p className="text-xs text-[#606060] text-start sm:text-left">
           {appointment.specialty}
            
          </p>
           
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-4">
        <div className="flex items-center justify-center gap-2 bg-[#f5f5f5] rounded-lg py-2 px-3">
          <LiaCalendarCheckSolid className="text-xl text-[#009A85]" />
          <div>
            <p className="text-[11px] text-[#606060] text-center">Date</p>
            <p className="text-[#009A85] text-[12px] font-semibold">{appointment.date}</p>
          </div>
        </div>
        <div className="flex items-center justify-center gap-2 bg-[#f5f5f5] rounded-lg py-2 px-3">
          <GiAlarmClock className="text-xl text-[#009A85]" />
          <div>
            <p className="text-[11px] text-[#606060] text-center">Time</p>
            <p className="text-[#009A85] text-[12px] font-semibold">{appointment.time}</p>
          </div>
        </div>
      </div>
  <p className="text-sm text-[#606060] text-center mb-4">
        Are you sure you want to cancel this appointment?
      </p>
      <div className="flex justify-center gap-4 mt-4">
        <button
          onClick={() => setShowCancelConfirmation(false)}
          className="px-4 py-2 text-sm bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition"
        >
          No, Keep
        </button>
        <button
         disabled={cancelling}
          onClick={handleCancelAppointment}
          className="px-4 py-2 text-sm bg-red-500 text-white rounded hover:bg-red-600 transition"
        >
           {cancelMessage}
        </button>
      </div>
    </div>
  </div>
)}
        {/* Header */}
       {/* Sticky Header and Top Section */}
<div className="sticky top-0 z-10 bg-white shadow-sm">
      <button
          onClick={onClose}
          className="absolute right-2 top-0 text-gray-600 text-lg hover:text-black"
        >
          ✖
      </button>
  {/* Header */}
  {appointment.flag !== "D" && (
  <div className="text-center text-lg font-bold border-b pb-3 mb-4 text-[#184A84]">
    Appointment Details
  </div>)}
  
 {/* Top Section - only show if flag !== "D" */}
{appointment.flag !== "D" && (
  <div className="flex justify-between items-center bg-gray-100 p-2 rounded-xl text-start mb-2">
    <div>
      <p className="text-[16px] font-semibold text-gray-900">{appointment.doctorName}</p>
      <p className="text-sm text-gray-500">{appointment.specialty}</p>
    </div>
    <div>
      <p className="text-sm font-medium text-[#184A84] mt-2">{appointment.time}</p>
      <p className="text-sm text-gray-500">{appointment.date}</p>
    </div>
    <div className="text-center">
      <div className="bg-[#184A84] p-1 rounded-full shadow-md inline-block">
        <BsCameraVideo className="text-white text-sm" />
      </div>
    </div>
  </div>
)}

</div>
{appointment.openAppointmentTab === "Upcomming" && ["S", "A"].includes(appointment.flag) ? (
   <div className="flex flex-col items-center justify-center mt-10 space-y-4 text-center animate-fade-in">
    <div className="text-[#184A84] text-5xl animate-bounce">
      <BsCameraVideo />
    </div>
    <p className="text-lg font-semibold text-gray-800">
      Your appointment is <span className="text-[#184A84]">upcoming</span>
    </p>
    <p className="text-sm text-gray-500 max-w-md">
      The consultation details will be available after the doctor’s session. 
      You’ll receive a notification once it’s completed.
    </p>
      <button  className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-md text-white transition bg-[#FF0004] hover:bg-red-600
       `}
      //  disabled={cancelling}
       onClick={()=> setShowCancelConfirmation(true)}
       >
             <FaTimesCircle size={18} />
            Cancel Appointment
           </button>
  </div>
):appointment.openAppointmentTab === "Upcomming" && ["C", "R"].includes(appointment.flag) ? (
   <div className="flex flex-col items-center justify-center mt-10 space-y-4 text-center animate-fade-in">
    <div
      className={`${
        appointment.flag === "C"
          ? "text-red-600"
         
          : appointment.flag === "R"
          ? "text-blue-600"
          : "text-gray-600"
      } text-5xl animate-bounce`}
    >
      <BsCameraVideo />
    </div>
    <p className="text-lg font-semibold text-gray-800">
      {appointment.flag === "C" && (
        <>
          Your appointment was <span className="text-red-600">cancelled</span>
        </>
      )}
     
      {appointment.flag === "R" && (
        <>
          Your appointment was <span className="text-blue-600">rescheduled</span>
        </>
      )}
    </p>
    <p className="text-sm text-gray-500 max-w-md">
      Please check your notifications or contact support if you have questions.
    </p>
  </div>
)  : 
(appointment.flag === "D" && appointmentDetail && doctorInfo)  ? ( 
<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
    {/* Mobile View */}
    <div className="block md:hidden relative bg-white rounded-2xl shadow-2xl w-full max-w-sm max-h-[80vh] overflow-y-auto">
      
      {/* Mobile Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-teal-100">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">E-Prescription</h3>
            <p className="text-xs text-gray-600">Medical Details</p>
          </div>
        </div>
        
        {/* Mobile Close Button */}
        <button
  onClick={onClose}  // ✅ Changed from placeholder comment
          className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-all duration-200"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Mobile Prescription Details */}
      <div className="p-6 space-y-6">
        {/* Patient Information */}
        <div className="bg-gray-50 rounded-xl p-4">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Patient Details
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Name:</span>
              <span className="font-medium text-gray-900">{patientInfo.patientName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Phone:</span>
              <span className="font-medium text-gray-900">{patientInfo.phoneNo}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Gender:</span>
              <span className="font-medium text-gray-900">{patientInfo.gender}</span>
            </div>
          </div>
        </div>

        {/* Appointment Information */}
        <div className="bg-gray-50 rounded-xl p-4">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3a2 2 0 012-2h4a2 2 0 012 2v4m-6 9l6 6m0 0l6-6m-6 6V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h6z" />
            </svg>
            Appointment Info
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Doctor:</span>
              <span className="font-medium text-gray-900">{doctorInfo.doctorName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Date:</span>
              <span className="font-medium text-gray-900">{doctorInfo.appointmentDate}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Time:</span>
              <span className="font-medium text-gray-900">{doctorInfo.slotStartTime}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Department:</span>
              <span className="font-medium text-gray-900">{doctorInfo.specializationName}</span>
            </div>
          </div>
        </div>

        {/* Chief Complaints */}
        <div className="bg-blue-50 rounded-xl p-4 border border-blue-100">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Chief Complaints
          </h4>
          <div className="text-sm">
            {appointmentDetail.CheifComplain ? (
              appointmentDetail.CheifComplain.split(",").map((item, idx) => (
                <div key={idx} className="flex items-start mb-1">
                  <span className="text-teal-600 mr-2">•</span>
                  <span className="text-gray-700">{item.trim()}</span>
                </div>
              ))
            ) : (
              <span className="text-gray-500 italic">None provided</span>
            )}
          </div>
        </div>

        {/* Diagnosis */}
        <div className="bg-yellow-50 rounded-xl p-4 border border-yellow-100">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            Diagnosis
          </h4>
          <div className="text-sm">
            {appointmentDetail.ProvisionalDiagnosis ? (
              appointmentDetail.ProvisionalDiagnosis.split(",").map((item, idx) => (
                <div key={idx} className="flex items-start mb-1">
                  <span className="text-teal-600 mr-2">•</span>
                  <span className="text-gray-700">{item.trim()}</span>
                </div>
              ))
            ) : (
              <span className="text-gray-500 italic">No diagnosis provided</span>
            )}
          </div>
        </div>

     
        {appointmentDetail.Medicines && appointmentDetail.Medicines.length > 0 && (
          <div className="bg-green-50 rounded-xl p-4 border border-green-100">
            <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
              <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
              Prescribed Medicines
            </h4>
            <div className="space-y-3">
              {appointmentDetail.Medicines.map((medicine, idx) => (
                <div key={idx} className="bg-white rounded-lg p-3 border border-green-200">
                  <div className="flex justify-between items-start mb-2">
                    <span className="font-medium text-gray-900 text-sm">{idx + 1}. {medicine.itemName}</span>
                    <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">{medicine.forDays} days</span>
                  </div>
                  <div className="text-xs text-gray-600">
                    <span className="mr-4">Dosage: {medicine.doseText}</span>
                    <span>Details: {medicine.doseValue}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Lab Tests */}
        {appointmentDetail.LabItems && appointmentDetail.LabItems.length > 0 && (
          <div className="bg-purple-50 rounded-xl p-4 border border-purple-100">
            <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
              <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
              </svg>
              Lab Investigations
            </h4>
            <div className="text-sm">
              {appointmentDetail.LabItems.map((lab, idx) => (
                <div key={idx} className="flex items-start mb-1">
                  <span className="text-teal-600 mr-2">•</span>
                  <span className="text-gray-700">{lab.serviceName}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Mobile Download Button */}
      <div className="p-6 pt-0">
        <PDFDownloadLink
          document={
            <AppointmentPDF
              appointmentId={appointment.appointmentId.toString()}
              doctorInfo={doctorInfo}
              patientInfo={patientInfo}
              appointmentDetail={appointmentDetail}
               followUpDate={"2025-01-24"}

            />
          }
          fileName={`${patientInfo.patientName}_EPrescription.pdf`}
        >
          {({ loading }) => (
            <button className="w-full py-4 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-xl font-semibold text-base transition-all duration-200 shadow-lg active:scale-95 flex items-center justify-center space-x-2">
              {loading ? (
                <>
                  <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                  <span>Preparing...</span>
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Download Prescription</span>
                </>
              )}
            </button>
          )}
        </PDFDownloadLink>
      </div>  
    </div>

    {/* Tablet View */}
  {/* Tablet View - Mobile-like Layout */}
<div className="hidden md:block lg:hidden relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
  
  {/* Tablet Header */}
  <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-teal-100">
    <div className="flex items-center space-x-4">
      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <div>
        <h3 className="text-xl font-bold text-gray-900">E-Prescription</h3>
        <p className="text-sm text-gray-600">Medical Details</p>
      </div>
    </div>
    
    {/* Tablet Close Button */}
    <button
      onClick={onClose}  // ✅ Changed from placeholder comment
      className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-200 hover:shadow-md"
    >
      <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  {/* Tablet Prescription Details - Same structure as mobile */}
  <div className="p-8 space-y-6">
    {/* Patient Information */}
    <div className="bg-gray-50 rounded-xl p-6">
      <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
        Patient Details
      </h4>
      <div className="space-y-3 text-base">
        <div className="flex justify-between">
          <span className="text-gray-600">Name:</span>
          <span className="font-medium text-gray-900">{patientInfo.patientName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Phone:</span>
          <span className="font-medium text-gray-900">{patientInfo.phoneNo}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Gender:</span>
          <span className="font-medium text-gray-900">{patientInfo.gender}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">ID:</span>
          <span className="font-medium text-gray-900">{appointment.appointmentId}</span>
        </div>
      </div>
    </div>

    {/* Appointment Information */}
    <div className="bg-gray-50 rounded-xl p-6">
      <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3a2 2 0 012-2h4a2 2 0 012 2v4m-6 9l6 6m0 0l6-6m-6 6V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h6z" />
        </svg>
        Appointment Info
      </h4>
      <div className="space-y-3 text-base">
        <div className="flex justify-between">
          <span className="text-gray-600">Doctor:</span>
          <span className="font-medium text-gray-900">{doctorInfo.doctorName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Date:</span>
          <span className="font-medium text-gray-900">{doctorInfo.appointmentDate}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Time:</span>
          <span className="font-medium text-gray-900">{doctorInfo.slotStartTime}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Department:</span>
          <span className="font-medium text-gray-900">{doctorInfo.specializationName}</span>
        </div>
      </div>
    </div>

    {/* Treatment Plan */}
    <div className="bg-gray-50 rounded-xl p-6">
      <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m6 5a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
        Treatment Plan
      </h4>
      <div className="text-base">
        {appointmentDetail.TreatmentPlan ? (
          appointmentDetail.TreatmentPlan.split(",").map((item, idx) => (
            <div key={idx} className="flex items-start mb-2">
              <span className="text-teal-600 mr-2">•</span>
              <span className="text-gray-700">{item.trim()}</span>
            </div>
          ))
        ) : (
          <span className="text-gray-500 italic">No treatment plan provided</span>
        )}
      </div>
    </div>

    {/* Chief Complaints */}
    <div className="bg-blue-50 rounded-xl p-6 border border-blue-100">
      <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        Chief Complaints
      </h4>
      <div className="text-base">
        {appointmentDetail.CheifComplain ? (
          appointmentDetail.CheifComplain.split(",").map((item, idx) => (
            <div key={idx} className="flex items-start mb-2">
              <span className="text-teal-600 mr-2">•</span>
              <span className="text-gray-700">{item.trim()}</span>
            </div>
          ))
        ) : (
          <span className="text-gray-500 italic">None provided</span>
        )}
      </div>
    </div>

    {/* Diagnosis */}
    <div className="bg-yellow-50 rounded-xl p-6 border border-yellow-100">
      <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
        Diagnosis
      </h4>
      <div className="text-base">
        {appointmentDetail.ProvisionalDiagnosis ? (
          appointmentDetail.ProvisionalDiagnosis.split(",").map((item, idx) => (
            <div key={idx} className="flex items-start mb-2">
              <span className="text-teal-600 mr-2">•</span>
              <span className="text-gray-700">{item.trim()}</span>
            </div>
          ))
        ) : (
          <span className="text-gray-500 italic">No diagnosis provided</span>
        )}
      </div>
    </div>

    {/* Medicines - Same as mobile layout */}
    {appointmentDetail.Medicines && appointmentDetail.Medicines.length > 0 && (
      <div className="bg-green-50 rounded-xl p-6 border border-green-100">
        <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
          <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
          Prescribed Medicines
        </h4>
        <div className="space-y-4">
          {appointmentDetail.Medicines.map((medicine, idx) => (
            <div key={idx} className="bg-white rounded-lg p-4 border border-green-200">
              <div className="flex justify-between items-start mb-3">
                <span className="font-medium text-gray-900 text-base">{idx + 1}. {medicine.itemName}</span>
                <span className="text-sm bg-green-100 text-green-800 px-3 py-1 rounded">{medicine.forDays} days</span>
              </div>
              <div className="text-sm text-gray-600">
                <span className="mr-6">Dosage: {medicine.doseText}</span>
                <span>Details: {medicine.doseValue}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {/* Lab Tests - Same as mobile layout */}
    {appointmentDetail.LabItems && appointmentDetail.LabItems.length > 0 && (
      <div className="bg-purple-50 rounded-xl p-6 border border-purple-100">
        <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
          <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
          </svg>
          Lab Investigations
        </h4>
        <div className="text-base">
          {appointmentDetail.LabItems.map((lab, idx) => (
            <div key={idx} className="flex items-start mb-2">
              <span className="text-teal-600 mr-2">•</span>
              <span className="text-gray-700">{lab.serviceName}</span>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>

  {/* Tablet Download Button */}
  <div className="p-8 pt-0">
    <PDFDownloadLink
      document={
        <AppointmentPDF
              appointmentId={appointment.appointmentId.toString()}
              doctorInfo={doctorInfo}
              patientInfo={patientInfo}
              appointmentDetail={appointmentDetail}
               followUpDate={"2025-01-24"}

            />
      }
      fileName={`${patientInfo.patientName}_EPrescription.pdf`}
    >
      {({ loading }) => (
        <button className="w-full py-4 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-xl font-semibold text-base transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2">
          {loading ? (
            <>
              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              <span>Preparing...</span>
            </>
          ) : (
            <>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span>Download Prescription</span>
            </>
          )}
        </button>
      )}
    </PDFDownloadLink>
  </div>

  {/* Tablet Footer */}
  <div className="px-8 pb-8">
    <div className="flex items-center justify-center space-x-2 text-sm text-gray-500 bg-gray-50 rounded-lg p-4">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>Download PDF for complete prescription details</span>
    </div>
  </div>
</div>

    {/* Desktop View */}
    <div className="hidden lg:block relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden">
      
      {/* Desktop Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-teal-100">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">E-Prescription</h3>
            <p className="text-sm text-gray-600">Medical Prescription for {patientInfo.patientName}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          {/* Desktop Download Button */}
          <PDFDownloadLink
            document={
               <AppointmentPDF
              appointmentId={appointment.appointmentId.toString()}
              doctorInfo={doctorInfo}
              patientInfo={patientInfo}
              appointmentDetail={appointmentDetail}
               followUpDate={"2025-01-24"}

            />
            }
            fileName={`${patientInfo.patientName}_EPrescription.pdf`}
          >
            {({ loading }) => (
              <button className="px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-xl font-semibold text-sm transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2">
                {loading ? (
                  <>
                    <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                    </svg>
                    <span>Preparing...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Download PDF</span>
                  </>
                )}
              </button>
            )}
          </PDFDownloadLink>
          
          {/* Desktop Close Button */}
          <button
  onClick={onClose}  // ✅ Changed from placeholder comment
            className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-200 hover:shadow-md"
          >
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Desktop Content Area */}
      <div className="flex h-[calc(90vh-140px)]">
        
        {/* Right Side - PDF Viewer */}
        <div className="flex-1 bg-gray-50">
          <div className="w-full h-full p-4">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 h-full overflow-hidden">
              <PDFViewer className="w-full h-full border-0 rounded-xl">
                 <AppointmentPDF
              appointmentId={appointment.appointmentId.toString()}
              doctorInfo={doctorInfo}
              patientInfo={patientInfo}
              appointmentDetail={appointmentDetail}
               followUpDate={"2025-01-24"}

            />
              </PDFViewer>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Footer */}
      <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Prescription generated successfully • Follow medication instructions carefully</span>
          </div>
          <div className="text-xs text-gray-400">
            Generated on {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  </div>


):appointment.openAppointmentTab === "Past" && ["C", "M", "R", "S", "A"].includes(appointment.flag) ? (
  <div className="flex flex-col items-center justify-center mt-10 space-y-4 text-center animate-fade-in">
    <div
      className={`${
        appointment.flag === "C"
          ? "text-red-600"
          : appointment.flag === "M" || appointment.flag === "S" || appointment.flag === "A"
          ? "text-yellow-600"
          : appointment.flag === "R"
          ? "text-blue-600"
          : "text-gray-600"
      } text-5xl animate-bounce`}
    >
      <BsCameraVideo />
    </div>
    <p className="text-lg font-semibold text-gray-800">
      {appointment.flag === "C" && (
        <>
          Your appointment was <span className="text-red-600">cancelled</span>
        </>
      )}
      {(appointment.flag === "M" || appointment.flag === "S" || appointment.flag === "A") && (
        <>
          Your appointment was <span className="text-yellow-600">missed</span>
        </>
      )}
      {appointment.flag === "R" && (
        <>
          Your appointment was <span className="text-blue-600">rescheduled</span>
        </>
      )}
    </p>
    <p className="text-sm text-gray-500 max-w-md">
      Please check your notifications or contact support if you have questions.
    </p>
  </div>
) : null}
      </div>
    </div>
  );
};

export default AppointmentDetailModal;
